// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__UUgP1","buttons":"Footer_buttons__3va37"};